import ProductService from '@/services/ProductService.js'
import AccountingService from '@/services/AccountingService.js'
export const namespaced = true

export const state = {
  products: [],
  productGroups: [],
  productLayoutTabs: [],
  deletingProductIds: [],
  deletingProductGroupIds: [],
  scannerInput: '',
  isLoadingSaveLayoutButtonButtons: [],
  formDialog: {
    show: false,
    isLoading: false,
    editedProduct: null,
    originalProduct: null,
    productUsedOnSettings: []
  },
  dialog: {
    show: false,
    isLoading: false,
    isSmaller: false,
    productId: null,
    product: null,
    salesHistory: null,
    editingRecords: [],
    cartCharges: [],
    isLoadingCartCharges: false
  },
  productGroupDialog: {
    show: false,
    isLoading: false,
    isSmaller: false,
    productGroupId: null,
    productGroup: null,
    salesHistory: null,
    editingRecords: []
  },
  productGroupFormDialog: {
    show: false,
    isLoading: false,
    editedProductGroup: null,
    originalProductGroup: null,
    accounts: []
  },
  triggerProductUpdated: 0 // För att trigga uppdatering av komponenter som visar produktdata när en produkt uppdateras
}

export const mutations = {
  SET_PRODUCTS (state, val) {
    state.products = val
  },
  REPLACE_OR_INSERT_PRODUCT (state, product) {
    let i = state.products.findIndex(arrayProduct => arrayProduct.id === product.id)
    if (i >= 0) {
      const oldProduct = state.products[i]
      state.products.splice(i, 1, product)

      // Om produktgrupp ändrats, uppdatera produkten i båda produktgrupperna
      if (oldProduct.product_group_id !== product.product_group_id) {
        const oldProductGroup = state.productGroups.find(pg => pg.id === oldProduct.product_group_id)
        if (oldProductGroup && oldProductGroup.products) {
          const oldIndex = oldProductGroup.products.findIndex(p => p.id === product.id)
          if (oldIndex >= 0) {
            oldProductGroup.products.splice(oldIndex, 1)
          }
        }
        const newProductGroup = state.productGroups.find(pg => pg.id === product.product_group_id)
        if (newProductGroup && newProductGroup.products) {
          newProductGroup.products.push(product)
        }
      } else {
        const productGroup = state.productGroups.find(arrayProductGroup => arrayProductGroup.id === product.product_group_id)
        if (productGroup && productGroup.products) {
          i = productGroup.products.findIndex(arrayProduct => arrayProduct.id === product.id)
          if (i >= 0) {
            productGroup.products.splice(i, 1, product)
          }
        }
      }
    } else {
      state.products.push(product)
      const productGroup = state.productGroups.find(arrayProductGroup => arrayProductGroup.id === product.product_group_id)
      if (productGroup && productGroup.products) {
        productGroup.products.push(product)
      }
    }

    // Uppdaterar product layouter eftersom de är berikade med produkterna, och de uppdateras inte för att produkten byts ut i en array
    window.enrich.enrichProductLayoutTab(state.productLayoutTabs)
  },
  REMOVE_PRODUCT (state, product) {
    let i = state.products.findIndex(arrayProduct => arrayProduct.id === product.id)
    if (i >= 0) {
      state.products.splice(i, 1)
    }
    // Tar bort produkten i productGroup.products också, obs fungerar bara om har samma product group som tidigare, tror inte product group får ändras utan att product får ny id
    const productGroup = state.productGroups.find(arrayProductGroup => arrayProductGroup.id === product.product_group_id)
    if (productGroup && productGroup.products) {
      i = productGroup.products.findIndex(arrayProduct => arrayProduct.id === product.id)
      if (i >= 0) {
        productGroup.products.splice(i, 1)
      }
    }
  },
  SET_PRODUCT_GROUPS (state, val) {
    state.productGroups = val
  },
  SET_DELETING_PRODUCT (state, val) {
    state.deletingProductIds.push(val)
  },
  SET_DELETING_PRODUCT_GROUP (state, val) {
    state.deletingProductGroupIds.push(val)
  },
  SET_SCANNER_INPUT (state, val) {
    state.scannerInput = val
  },
  REMOVE_DELETING_PRODUCT (state, val) {
    state.deletingProductIds.splice(state.deletingProductIds.indexOf(val), 1)
  },
  REMOVE_DELETING_PRODUCT_GROUP (state, val) {
    state.deletingProductGroupIds.splice(state.deletingProductGroupIds.indexOf(val), 1)
  },
  SET_IS_LOADING_SAVE_LAYOUT_BUTTON (state, payload) {
    if (payload.val) {
      const i = state.isLoadingSaveLayoutButtonButtons.findIndex(btn => btn.id === payload.button.id && btn.product_layout_tab_id === payload.button.product_layout_tab_id && btn.row === payload.button.row && btn.column === payload.button.column)
      if (i < 0) {
        state.isLoadingSaveLayoutButtonButtons.push(payload.button)
      }
    } else {
      const i = state.isLoadingSaveLayoutButtonButtons.findIndex(btn => btn.id === payload.button.id && btn.product_layout_tab_id === payload.button.product_layout_tab_id && btn.row === payload.button.row && btn.column === payload.button.column)
      state.isLoadingSaveLayoutButtonButtons.splice(i, 1)
    }
  },
  REPLACE_OR_INSERT_LAYOUT_BUTTON (state, button) {
    const productLayoutTab = state.productLayoutTabs.find(productLayoutTab => productLayoutTab.id === button.product_layout_tab_id)
    if (productLayoutTab) {
      const i = productLayoutTab.product_layout_buttons.findIndex(productLayoutButton => productLayoutButton.id === button.id)
      if (i >= 0) {
        productLayoutTab.product_layout_buttons.splice(i, 1, button)
      } else {
        productLayoutTab.product_layout_buttons.push(button)
      }
    }
  },
  REMOVE_LAYOUT_BUTTON (state, button) {
    const productLayoutTab = state.productLayoutTabs.find(productLayoutTab => productLayoutTab.id === button.product_layout_tab_id)
    if (productLayoutTab) {
      const i = productLayoutTab.product_layout_buttons.findIndex(productLayoutButton => productLayoutButton.id === button.id)
      if (i >= 0) {
        productLayoutTab.product_layout_buttons.splice(i, 1)
      }
    }
  },
  SET_EDITED_PRODUCT (state, val) {
    state.formDialog.editedProduct = val
  },
  SET_ORIGINAL_PRODUCT (state, val) {
    state.formDialog.originalProduct = val
  },
  SET_SHOW_FORM_DIALOG (state, val) {
    state.formDialog.show = val
  },
  SET_FORM_DIALOG_PRODUCT_USED_ON_SETTINGS (state, val) {
    state.formDialog.productUsedOnSettings = val
  },
  SET_SHOW_DIALOG (state, val) {
    state.dialog.show = val
  },
  SET_DIALOG_IS_LOADING (state, val) {
    state.dialog.isLoading = val
  },
  SET_DIALOG_PRODUCT (state, val) {
    state.dialog.product = val
  },
  SET_DIALOG_PRODUCT_ID (state, val) {
    state.dialog.productId = val
  },
  SET_DIALOG_SALES_HISTORY (state, val) {
    state.dialog.salesHistory = val
  },
  SET_DIALOG_IS_SMALLER (state, val) {
    state.dialog.isSmaller = val
  },
  SET_DIALOG_EDITING_RECORDS (state, val) {
    state.dialog.editingRecords = val
  },
  SET_DIALOG_CART_CHARGES (state, val) {
    state.dialog.cartCharges = val
  },
  SET_DIALOG_IS_LOADING_CART_CHARGES (state, val) {
    state.dialog.isLoadingCartCharges = val
  },
  SET_PRODUCT_LAYOUT_TABS (state, val) {
    state.productLayoutTabs = val
  },
  SET_SHOW_PRODUCT_GROUP_DIALOG (state, val) {
    state.productGroupDialog.show = val
  },
  SET_PRODUCT_GROUP_DIALOG_IS_SMALLER (state, val) {
    state.productGroupDialog.isSmaller = val
  },
  SET_PRODUCT_GROUP_DIALOG_IS_LOADING (state, val) {
    state.productGroupDialog.isLoading = val
  },
  SET_PRODUCT_GROUP_DIALOG_PRODUCT_GROUP (state, val) {
    state.productGroupDialog.productGroup = val
  },
  SET_PRODUCT_GROUP_DIALOG_PRODUCT_GROUP_ID (state, val) {
    state.productGroupDialog.productGroupId = val
  },
  SET_PRODUCT_GROUP_DIALOG_SALES_HISTORY (state, val) {
    state.productGroupDialog.salesHistory = val
  },
  SET_PRODUCT_GROUP_DIALOG_EDITING_RECORDS (state, val) {
    state.productGroupDialog.editingRecords = val
  },
  REPLACE_OR_INSERT_PRODUCT_GROUP (state, productGroup) {
    const i = state.productGroups.findIndex(pg => pg.id === productGroup.id)
    if (i >= 0) {
      state.productGroups.splice(i, 1, productGroup)
    } else {
      state.productGroups.push(productGroup)
    }
  },
  SET_SHOW_PRODUCT_GROUP_FORM_DIALOG (state, val) {
    state.productGroupFormDialog.show = val
  },
  SET_PRODUCT_GROUP_FORM_DIALOG_IS_LOADING (state, val) {
    state.productGroupFormDialog.isLoading = val
  },
  SET_EDITED_PRODUCT_GROUP (state, val) {
    state.productGroupFormDialog.editedProductGroup = val
  },
  SET_ORIGINAL_PRODUCT_GROUP (state, val) {
    state.productGroupFormDialog.originalProductGroup = val
  },
  SET_PRODUCT_GROUP_FORM_ACCOUNTS (state, val) {
    state.productGroupFormDialog.accounts = val
  },
  TRIGGER_PRODUCT_UPDATED (state) {
    state.triggerProductUpdated++
  }
}

export const actions = {
  openDialogById ({ state, commit, dispatch }, { productId, smaller = false }) {
    const reopenNeeded = state.dialog.show

    if (smaller && state.productGroupDialog.show) {
      commit('SET_PRODUCT_GROUP_DIALOG_IS_SMALLER', false)
    }

    const doOpen = () => {
      commit('SET_DIALOG_IS_SMALLER', smaller)
      commit('SET_DIALOG_PRODUCT_ID', productId)
      commit('SET_DIALOG_PRODUCT', null)
      commit('SET_DIALOG_SALES_HISTORY', null)
      commit('SET_DIALOG_EDITING_RECORDS', [])
      commit('SET_DIALOG_CART_CHARGES', [])
      commit('SET_DIALOG_IS_LOADING', true)
      commit('SET_SHOW_DIALOG', true)

      commit('SET_DIALOG_IS_LOADING_CART_CHARGES', true)
      ProductService.getCartCharges({ productId })
        .then(({ data }) => {
          if (data.status === 'success' && productId === state.dialog.productId) {
            commit('SET_DIALOG_CART_CHARGES', data.data.charges)
          }
        })
        .finally(() => {
          if (productId === state.dialog.productId || !state.dialog.show) {
            commit('SET_DIALOG_IS_LOADING_CART_CHARGES', false)
          }
        })

      return Promise.allSettled([
        ProductService.getProduct({ productId })
          .then(({ data }) => {
            if (data.status === 'success' && productId === state.dialog.productId) {
              window.enrich.enrichProduct(data.data.product)
              if (data.data.sales_history) {
                data.data.sales_history.forEach(salesObject => {
                  salesObject.month = window.dayjs.parseServerDate(salesObject.month)
                })
              }
              commit('SET_DIALOG_PRODUCT', data.data.product)
              commit('SET_DIALOG_SALES_HISTORY', data.data.sales_history)
            }
          }),
        dispatch('getProductEditingRecords', productId)
      ])
        .finally(() => {
          if (productId === state.dialog.productId || !state.dialog.show) {
            commit('SET_DIALOG_IS_LOADING', false)
          }
        })
    }

    if (reopenNeeded) {
      commit('SET_SHOW_DIALOG', false)
      return new Promise(resolve => {
        setTimeout(() => { resolve(doOpen()) }, 50)
      })
    }
    return doOpen()
  },
  openProductGroupDialogById ({ state, commit, dispatch }, { productGroupId, smaller = false }) {
    const reopenNeeded = state.productGroupDialog.show

    if (smaller && state.dialog.show) {
      commit('SET_DIALOG_IS_SMALLER', false)
    }

    const doOpen = () => {
      commit('SET_PRODUCT_GROUP_DIALOG_IS_SMALLER', smaller)
      commit('SET_PRODUCT_GROUP_DIALOG_PRODUCT_GROUP_ID', productGroupId)
      commit('SET_PRODUCT_GROUP_DIALOG_PRODUCT_GROUP', null)
      commit('SET_PRODUCT_GROUP_DIALOG_SALES_HISTORY', null)
      commit('SET_PRODUCT_GROUP_DIALOG_EDITING_RECORDS', [])
      commit('SET_PRODUCT_GROUP_DIALOG_IS_LOADING', true)
      commit('SET_SHOW_PRODUCT_GROUP_DIALOG', true)

      return Promise.allSettled([
        ProductService.getProductGroup({ productGroupId })
          .then(({ data }) => {
            if (data.status === 'success' && productGroupId === state.productGroupDialog.productGroupId) {
              if (data.data.sales_history) {
                data.data.sales_history.forEach(salesObject => {
                  salesObject.month = window.dayjs.parseServerDate(salesObject.month)
                })
              }
              commit('SET_PRODUCT_GROUP_DIALOG_PRODUCT_GROUP', data.data.product_group)
              commit('SET_PRODUCT_GROUP_DIALOG_SALES_HISTORY', data.data.sales_history)
            }
          }),
        dispatch('getProductGroupEditingRecords', productGroupId)
      ])
        .finally(() => {
          if (productGroupId === state.productGroupDialog.productGroupId || !state.productGroupDialog.show) {
            commit('SET_PRODUCT_GROUP_DIALOG_IS_LOADING', false)
          }
        })
    }

    if (reopenNeeded) {
      commit('SET_SHOW_PRODUCT_GROUP_DIALOG', false)
      return new Promise(resolve => {
        setTimeout(() => { resolve(doOpen()) }, 50)
      })
    }
    return doOpen()
  },
  scannedBarcode ({ state, dispatch }, barcode) {
    const product = state.products.find(prod => prod.barcode === barcode)
    if (product) {
      // Hittade en sparad product med skannad barcode
      dispatch('posCart/addToCart', { product }, { root: true })
    } else {
      // Hittade ingen product
      dispatch('openNewProductFormDialog', { barcode })
    }
  },
  openNewProductFormDialog ({ commit }, { barcode = null, productGroupId = null } = {}) {
    const newProduct = {
      id: 0,
      barcode,
      gui_color: 'blue',
      name: '',
      price: null,
      product_group_id: productGroupId,
      unit_id: 1
    }
    commit('SET_EDITED_PRODUCT', newProduct)
    commit('SET_ORIGINAL_PRODUCT', null)
    commit('SET_FORM_DIALOG_PRODUCT_USED_ON_SETTINGS', [])
    commit('SET_SHOW_FORM_DIALOG', true)
  },
  barcodeInputRequest ({ commit }, { input }) {
    commit('SET_SCANNER_INPUT', input)
  },
  reloadProducts ({ commit, dispatch }) {
    // Hämtar om products och tillhörande, product groups och product layout tabs
    commit('SET_IS_LOADING_PAGE', true, { root: true })
    return Promise.allSettled([
      dispatch('fetchProducts')/* ,
      dispatch('fetchProductGroups'),
      dispatch('fetchProductLayoutTabs') */
    ])
      .then(() => {
        return Promise.allSettled([
          dispatch('enrichProducts'),
          dispatch('enrichProductGroups'),
          dispatch('enrichProductLayoutTabs')
        ])
          .finally(() => {
            commit('SET_IS_LOADING_PAGE', false, { root: true })
          })
      })
      .catch(() => {
        commit('SET_IS_LOADING_PAGE', false, { root: true })
      })
  },
  fetchProducts ({ commit }) {
    return ProductService.getProducts()
      .then(({ data }) => {
        commit('SET_PRODUCTS', data.data.products)
        if (data.data.product_layout_tabs) {
          commit('SET_PRODUCT_LAYOUT_TABS', data.data.product_layout_tabs)
        }
        if (data.data.product_groups) {
          commit('SET_PRODUCT_GROUPS', data.data.product_groups)
        }
      })
  },
  enrichProducts ({ state }) {
    return new Promise((resolve, reject) => {
      window.enrich.enrichProduct(state.products)
      resolve(true)
    })
  },
  fetchProductGroups ({ commit }) {
    return ProductService.getProductGroups()
      .then(({ data }) => {
        commit('SET_PRODUCT_GROUPS', data.data.product_groups)
      })
  },
  enrichProductGroups ({ state }) {
    return new Promise((resolve, reject) => {
      window.enrich.enrichProductGroup(state.productGroups)
      resolve(true)
    })
  },
  fetchProductLayoutTabs ({ commit }) {
    return ProductService.getProductLayoutTabs()
      .then(({ data }) => {
        commit('SET_PRODUCT_LAYOUT_TABS', data.data.product_layout_tabs)
      })
  },
  enrichProductLayoutTabs ({ state }) {
    return new Promise((resolve, reject) => {
      window.enrich.enrichProductLayoutTab(state.productLayoutTabs)
      resolve(true)
    })
  },
  saveLayoutButton ({ state, commit, dispatch }, button) {
    const productLayoutTab = state.productLayoutTabs.find(productLayoutTab => productLayoutTab.id === button.product_layout_tab_id)
    commit('SET_IS_LOADING_SAVE_LAYOUT_BUTTON', { button, val: true })
    window.enrich.enrichProductLayoutTab(productLayoutTab)
    ProductService.saveLayoutButton({
      button
    })
      .then(({ data }) => {
        if (data.status === 'success') {
          commit('REPLACE_OR_INSERT_LAYOUT_BUTTON', data.data)
          dispatch('snackbars/createSnackbar', {
            color: 'success',
            text: button.id === 0 ? 'Knappen har skapats' : 'Knappen har uppdaterats'
          }, { root: true })
          commit('SET_IS_LOADING_SAVE_LAYOUT_BUTTON', { button, val: false }) // För att det ska bli rätt när layout tabben berikas i nästa steg
          window.enrich.enrichProductLayoutTab(productLayoutTab)
        }
      })
      .finally(() => {
        commit('SET_IS_LOADING_SAVE_LAYOUT_BUTTON', { button, val: false })
      })
  },
  deleteLayoutButton ({ state, commit, dispatch }, button) {
    const productLayoutTab = state.productLayoutTabs.find(productLayoutTab => productLayoutTab.id === button.product_layout_tab_id)
    commit('SET_IS_LOADING_SAVE_LAYOUT_BUTTON', { button, val: true })
    window.enrich.enrichProductLayoutTab(productLayoutTab)
    ProductService.deleteLayoutButton({
      buttonId: button.id
    })
      .then(({ data }) => {
        if (data.status === 'success') {
          commit('REMOVE_LAYOUT_BUTTON', button)
          dispatch('snackbars/createSnackbar', {
            color: 'success',
            text: 'Knappen har tagits bort'
          }, { root: true })
          commit('SET_IS_LOADING_SAVE_LAYOUT_BUTTON', { button, val: false }) // För att det ska bli rätt när layout tabben berikas i nästa steg
          window.enrich.enrichProductLayoutTab(productLayoutTab)
        }
      })
      .finally(() => {
        commit('SET_IS_LOADING_SAVE_LAYOUT_BUTTON', { button, val: false })
      })
  },
  startEditProduct ({ commit }, { product }) {
    commit('SET_EDITED_PRODUCT', {
      id: product.id,
      name: product.name,
      product_group_id: product.product_group_id,
      barcode: product.barcode,
      price: product.price,
      gui_color: product.gui_color,
      should_have_delivery_date: product.should_have_delivery_date,
      default_delivery_date: product.default_delivery_date
    })
    commit('SET_ORIGINAL_PRODUCT', product)
    commit('SET_FORM_DIALOG_PRODUCT_USED_ON_SETTINGS', product.used_on_settings || [])
    commit('SET_SHOW_FORM_DIALOG', true)
  },
  saveProduct ({ state, commit, dispatch }) {
    const editedProduct = state.formDialog.editedProduct
    return ProductService.saveProduct({
      productId: editedProduct.id,
      name: editedProduct.name,
      productGroupId: editedProduct.product_group_id,
      barcode: editedProduct.barcode,
      price: editedProduct.price,
      guiColor: editedProduct.gui_color,
      shouldHaveDeliveryDate: editedProduct.should_have_delivery_date,
      defaultDeliveryDate: editedProduct.default_delivery_date
    })
      .then(({ data }) => {
        if (data.status === 'success') {
          window.enrich.enrichProduct(data.data.product)
          commit('REPLACE_OR_INSERT_PRODUCT', data.data.product)
          commit('TRIGGER_PRODUCT_UPDATED')
          if (state.dialog.productId === editedProduct.id || state.dialog.productId === data.data.product.id) {
            commit('SET_DIALOG_PRODUCT', data.data.product)
            commit('SET_DIALOG_PRODUCT_ID', data.data.product.id)
            dispatch('getProductEditingRecords', data.data.product.id)
          }
          commit('SET_SHOW_FORM_DIALOG', false)
        }
      })
      .finally(() => {
        //
      })
  },
  deleteProduct ({ commit, dispatch }, { product }) {
    commit('SET_DELETING_PRODUCT', product.id)
    return ProductService.deleteProduct({ productId: product.id })
      .then(({ data }) => {
        if (data.status === 'success') {
          dispatch('snackbars/createSnackbar', {
            color: 'success',
            text: 'Produkten har inaktiverats'
          }, { root: true })
          if (data.data.refresh_layout) {
            // Produkten fanns med i en layout, tillhörande knappar har tagits bort serverside, uppdatera layouts lokalt också
            commit('SET_PRODUCT_LAYOUT_TABS', data.data.layout_tabs)
          }
          commit('REMOVE_PRODUCT', product)
          commit('TRIGGER_PRODUCT_UPDATED')
        }
        return data
      })
      .finally(() => {
        commit('REMOVE_DELETING_PRODUCT', product.id)
      })
  },
  deleteProductGroup ({ commit, dispatch }, productGroup) {
    // Disablat knapp till denna tillsvidare ännu 11/4-22
    commit('SET_DELETING_PRODUCT_GROUP', productGroup.id)
    return ProductService.deleteProductGroup({ productGroupId: productGroup.id })
      .then(({ data }) => {
        dispatch('snackbars/createSnackbar', {
          color: 'success',
          text: 'Produktgruppen och tillhörande produkter har inaktiverats'
        }, { root: true })
        commit('TRIGGER_PRODUCT_UPDATED')
      })
      .finally(() => {
        commit('REMOVE_DELETING_PRODUCT_GROUP', productGroup.id)
      })
  },
  startEditProductGroup ({ state, commit }, { productGroup }) {
    commit('SET_EDITED_PRODUCT_GROUP', {
      id: productGroup.id,
      name: productGroup.name,
      account_id: productGroup.account_id,
      product_type: productGroup.product_type
    })
    commit('SET_ORIGINAL_PRODUCT_GROUP', productGroup)
    commit('SET_PRODUCT_GROUP_FORM_ACCOUNTS', [])
    commit('SET_PRODUCT_GROUP_FORM_DIALOG_IS_LOADING', true)
    commit('SET_SHOW_PRODUCT_GROUP_FORM_DIALOG', true)

    AccountingService.getIncomeAccounts()
      .then(({ data }) => {
        if (data.status === 'success') {
          commit('SET_PRODUCT_GROUP_FORM_ACCOUNTS', data.data.accounts)
        }
      })
      .finally(() => {
        commit('SET_PRODUCT_GROUP_FORM_DIALOG_IS_LOADING', false)
      })
  },
  openNewProductGroupFormDialog ({ commit }) {
    commit('SET_EDITED_PRODUCT_GROUP', {
      id: 0,
      name: '',
      account_id: null,
      product_type: null
    })
    commit('SET_ORIGINAL_PRODUCT_GROUP', null)
    commit('SET_PRODUCT_GROUP_FORM_ACCOUNTS', [])
    commit('SET_PRODUCT_GROUP_FORM_DIALOG_IS_LOADING', true)
    commit('SET_SHOW_PRODUCT_GROUP_FORM_DIALOG', true)

    AccountingService.getIncomeAccounts()
      .then(({ data }) => {
        if (data.status === 'success') {
          commit('SET_PRODUCT_GROUP_FORM_ACCOUNTS', data.data.accounts)
        }
      })
      .finally(() => {
        commit('SET_PRODUCT_GROUP_FORM_DIALOG_IS_LOADING', false)
      })
  },
  saveProductGroup ({ state, commit, dispatch }) {
    const editedProductGroup = state.productGroupFormDialog.editedProductGroup
    commit('SET_PRODUCT_GROUP_FORM_DIALOG_IS_LOADING', true)
    return ProductService.saveProductGroup({
      productGroupId: editedProductGroup.id,
      name: editedProductGroup.name,
      accountId: editedProductGroup.account_id,
      productType: editedProductGroup.product_type
    })
      .then(({ data }) => {
        if (data.status === 'success') {
          commit('REPLACE_OR_INSERT_PRODUCT_GROUP', data.data.product_group)
          if (state.productGroupDialog.productGroupId === editedProductGroup.id || state.productGroupDialog.productGroupId === data.data.product_group.id) {
            commit('SET_PRODUCT_GROUP_DIALOG_PRODUCT_GROUP', data.data.product_group)
            commit('SET_PRODUCT_GROUP_DIALOG_PRODUCT_GROUP_ID', data.data.product_group.id)
            dispatch('getProductGroupEditingRecords', data.data.product_group.id)
          }
          commit('SET_SHOW_PRODUCT_GROUP_FORM_DIALOG', false)
          commit('TRIGGER_PRODUCT_UPDATED')
        }
      })
      .finally(() => {
        commit('SET_PRODUCT_GROUP_FORM_DIALOG_IS_LOADING', false)
      })
  },
  getProductEditingRecords ({ state, commit }, productId) {
    return ProductService.getEditingRecords({ productId })
      .then(({ data }) => {
        if (data.status === 'success' && productId === state.dialog.productId) {
          commit('SET_DIALOG_EDITING_RECORDS', data.data.editing_records)
        }
      })
  },
  getProductGroupEditingRecords ({ state, commit }, productGroupId) {
    return ProductService.getProductGroupEditingRecords({ productGroupId })
      .then(({ data }) => {
        if (data.status === 'success' && productGroupId === state.productGroupDialog.productGroupId) {
          commit('SET_PRODUCT_GROUP_DIALOG_EDITING_RECORDS', data.data.editing_records)
        }
      })
  }
}
